module.exports = __webpack_public_path__ + "img/材料力学7_3_4.7206fc1c.jpg";